import styled from "styled-components";

export const Container = styled.div`
  border-radius: 5px;
  border: 1px solid #eee;
  padding: 20px;
  display: flex;
  align-items: center;
  background: white;
  display: flex;
  justify-content: space-between;
  position: relative; 
  height: 66px;
  @media (min-width: 426px) {
  }
`;

export const Required = styled.span`
  border-radius: 20px;
  padding: 3px;
  color: white;
  font-weight: bold;
  font-size: 8px;
  background: ${({ theme }) => theme.palette.primary.main};
  @media (min-width: 426px) {
    font-size: 12px;
    padding: 5px;
  }
  ${({ show }) => !show && "display:none"}
  ${({ disabled }) => disabled && "background:#ddd"}
`;

export const Title = styled.h3`
  font-size: 14px;
  margin: 0;
  @media (min-width: 426px) {
    font-size: 20px;
  }
  ${({ disabled }) => disabled && "color:#ddd"}
`;

export const Actions = styled.div`
  display: flex;
  & > * {
    margin-left: 10px;
  }
`;
